/** @jsx jsx */

import { ComponentProps } from 'react';

import { Alert } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  requestStatus: ComponentProps<typeof Alert>['status'];
};

const StatusIndicator = ({ requestStatus }: Props) => (
  <Alert status={requestStatus}>
    Request {requestStatus === 'success' ? 'Successful' : 'Failed'}
  </Alert>
);

export default StatusIndicator;
